import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { VENTURES } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Ventures = () => (
  <section data-testid="ventures-section" id="ventures" className="relative py-28 lg:py-40 bg-charcoal-900">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <div className="lg:col-span-8">
          <Reveal>
            <Eyebrow testid="ventures-eyebrow">Founder · 4 Ventures</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
              I don't just advise growth — <span className="italic text-gold-gradient">I've built it.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-4">
          <p className="text-cream/55 text-base sm:text-lg leading-relaxed">
            Four companies founded across marketing, ecommerce and community — so when I sit
            across from a founder, I've been in that seat too.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        {VENTURES.map((v, i) => {
          const Wrapper = v.url ? motion.a : motion.div;
          const linkProps = v.url ? { href: v.url, target: "_blank", rel: "noreferrer" } : {};
          return (
            <Wrapper
              key={v.name}
              data-testid={`venture-card-${i}`}
              {...linkProps}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative block border border-white/10 rounded-3xl p-8 lg:p-10 bg-charcoal-800/40 transition-colors duration-500 overflow-hidden ${
                v.url ? "hover:border-gold/40 cursor-pointer" : "hover:border-gold/30"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="text-[11px] uppercase tracking-[0.25em] text-gold">{v.role}</span>
                <span className="font-serif text-4xl text-gold/20 leading-none">0{i + 1}</span>
              </div>
              <div className="flex items-center gap-3 mt-5">
                <h3 className="font-serif text-3xl sm:text-4xl text-cream">{v.name}</h3>
                {v.url && (
                  <span className="h-9 w-9 rounded-full border border-white/15 flex items-center justify-center text-gold/70 group-hover:border-gold group-hover:text-gold group-hover:rotate-45 transition-all duration-300">
                    <ArrowUpRight size={18} />
                  </span>
                )}
              </div>
              <p className="text-cream/55 text-sm sm:text-base leading-relaxed mt-4">{v.desc}</p>
              {v.url && (
                <span data-testid={`venture-link-${i}`} className="inline-block mt-5 text-gold text-sm">
                  {v.url.replace(/^https?:\/\//, "")}
                </span>
              )}
              <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold group-hover:w-full transition-all duration-700" />
            </Wrapper>
          );
        })}
      </div>
    </div>
  </section>
);
